export const columnConfigs = {
  default: [
    { key: 'interface-size', text: 'Interface Size', field: 'field_interface_size_name' },
    { key: 'norm-size', text: 'Norm Size', field: 'field_norm_size_name' },
  ],
  collets: [
    { key: 'o-mm', text: 'Ø [mm]', field: 'o_mm' },
    { key: 'norm-size', text: 'Norm Size', field: 'field_norm_size_name' },
  ],
  toolholders: [
    { key: 'lpr-mm', text: 'LPR [mm]', field: 'lpr_mm' },
    { key: 'norm-size', text: 'Norm Size', field: 'field_norm_size_name' },
  ]
};

export const sortingOptions = () => {

  if (!window.Drupal) {
    window.Drupal = {
      t: (str) => { return str; }
    };
  }

  return [
    {label: window.Drupal.t("Interface Size") + " ASC", field: "field_interface_size_name", order: "asc"},
    {label: window.Drupal.t("Interface Size") + " DESC", field: "field_interface_size_name", order: "desc"},
    {label: window.Drupal.t("Norm Size") + " ASC", field: "field_norm_size_name", order: "asc"},
    {label: window.Drupal.t("Norm Size") + " DESC", field: "field_norm_size_name", order: "desc"},
    {label: window.Drupal.t("L [mm]") + " ASC", field: "l_mm", order: "asc"},
    {label: window.Drupal.t("L [mm]") + " DESC", field: "l_mm", order: "desc"},
    {label: window.Drupal.t("Ø [mm]") + " ASC", field: "o_mm", order: "asc"},
    {label: window.Drupal.t("Ø [mm]") + " DESC", field: "o_mm", order: "desc"},
    {label: window.Drupal.t("LPR [mm]") + " ASC", field: "lpr_mm", order: "asc"},
    {label: window.Drupal.t("LPR [mm]") + " DESC", field: "lpr_mm", order: "desc"},
  ];
}

export function getColumnConfig (productType){
  return columnConfigs[productType] ? columnConfigs[productType] : columnConfigs['default'];
}



// WEBPACK FOOTER //
// ./src/column-configs.js